module.exports = __webpack_public_path__ + "img/non-melanoma-skin-cancer-leaflet.562349d5.jpg";